import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import DraftItemAssetsUploadContainer from './DraftItemAssetsUploadContainer';
import LinearProgress from '../../../core/layout/LinearProgress';

const DraftItemAssetsList = (props) => {
  return (
    <Table
      rowKey={(row) => `${row.type}-${row.text}`}
      columns={[
        {
          label: 'Actions',
          path: 'action',
          width: '85px',
          align: 'center',
          render: (cell, row) => {
            if (!!row.uploadPercentage && row.uploadPercentage < 100) {
              return <LinearProgress value={row.uploadPercentage} showInfo={false} />;
            } else {
              return (
                <DraftItemAssetsUploadContainer
                  field={row.field}
                  accept={row.type.toLowerCase()}
                  value={props.item[row.field]}
                  itemId={props.item.id}
                  itemType={props.item.type.key}
                  onItemAssetUploadPercentageChange={props.onItemAssetUploadPercentageChange}
                />
              );
            }
          },
        },
        {
          label: 'Type',
          path: 'type',
          width: '100px',
        },
        {
          label: 'Location',
          path: 'location',
          width: '120px',
        },
        {
          label: 'Text',
          path: 'text',
        },
      ]}
      rows={props.assets}
      showTableCount={false}
    />
  );
};

DraftItemAssetsList.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.shape({
      key: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.string,
      location: PropTypes.string,
    })
  ).isRequired,
  onItemAssetUploadPercentageChange: DraftItemAssetsUploadContainer.propTypes.onItemAssetUploadPercentageChange,
};

export default DraftItemAssetsList;
